import { X } from "lucide-react"
import { HTMLAttributes } from "react"
import { TagColor } from "shared-ts/libs/tag"

import { classNames } from "../../../../lib/classNames"
import { Icon, IconSizes } from "../../../Icon"

const tagColorClasses: Record<TagColor, string> = {
  [TagColor.Undefined]: "bg-transparent",
  [TagColor.Red]: "border border-v2-border-tag-red bg-v2-background-tag-red",
  [TagColor.Pink]: "border border-v2-border-tag-pink bg-v2-background-tag-pink",
  [TagColor.Purple]:
    "border border-v2-border-tag-purple bg-v2-background-tag-purple",
  [TagColor.Blue]: "border border-v2-border-tag-blue bg-v2-background-tag-blue",
  [TagColor.Cyan]: "border border-v2-border-tag-cyan bg-v2-background-tag-cyan",
  [TagColor.Green]:
    "border border-v2-border-tag-green bg-v2-background-tag-green",
  [TagColor.Yellow]:
    "border border-v2-border-tag-yellow bg-v2-background-tag-yellow",
  [TagColor.Gray]: "border border-v2-border-tag-gray bg-v2-background-tag-gray",
}

export interface TagProps extends HTMLAttributes<HTMLDivElement> {
  name?: string
  color: TagColor
  isColorSwatchTag?: boolean
  onDelete?: () => void
}

export function Tag({
  name,
  color,
  onDelete,
  className,
  isColorSwatchTag,
  ...otherProps
}: TagProps) {
  return (
    <div
      className={classNames(
        "flex items-center gap-x-1",
        "h-6.5 w-fit",
        "rounded-control px-2",
        tagColorClasses[color],
        isColorSwatchTag && "rounded-mark size-4 px-0",
        className
      )}
      {...otherProps}
    >
      <span
        className={classNames(
          "text-body select-none whitespace-nowrap",
          "color-default opacity-90"
        )}
      >
        {name}
      </span>
      {onDelete && (
        <button
          type="button"
          aria-label={`Remove ${name}`}
          className="rounded-control group/remove -mx-1 flex size-6 items-center justify-center"
          onClick={(e) => {
            e.stopPropagation()
            onDelete()
          }}
        >
          <Icon
            icon={X}
            size={IconSizes.ExtraSmall}
            className="text-v2-foreground-default opacity-50 group-focus-visible/remove:opacity-75 group-active/remove:opacity-75"
          />
        </button>
      )}
    </div>
  )
}
